import { cloneDeep, set } from "lodash-es"
import React, { useState } from "react"
import CustomDialog from "components/Atoms/CustomDialog"
import ButtonMutation from "components/Molecules/ButtonMutation"
import { ApolloErrorToast, SuccessToast } from "utils/AppToaster"
import { ARRIVED_DOCK } from "graphql/dms/dms.mutations.gql"
import CustomFormGroup from "components/Atoms/CustomFormGroup"
import CustomDatePicker from "components/Atoms/CustomDatePicker"
import { Position } from "@blueprintjs/core"
import { TimePrecision } from "@blueprintjs/datetime"
import CustomButton from "components/Atoms/CustomButton"
import { useNavigate } from "react-router-dom"
const ReadyToLeaveDialog = ({
  tripId,
  otp,
  isOpen,
  onClose,
  ...otherProps
}) => {
  const navigate = useNavigate()

  const [state, setState] = useState({
    timestamp: new Date(),
  })

  function handleChange(path, value) {
    const stateCopy = cloneDeep(state)
    set(stateCopy, path, value)
    setState(stateCopy)
  }

  return (
    <CustomDialog
      title={
        <div>
          <text>Vehicle status</text>
        </div>
      }
      isOpen={isOpen}
      footerRightButton={
        <ButtonMutation
          icon="confirm"
          text="Yes"
          mutation={ARRIVED_DOCK}
          variables={{
            tripId,
            stepId: "79a3567e-66b3-44b5-a4a0-7f489a812cbe",
            timestamp: new Date(state.timestamp).toISOString(),
          }}
          onError={err => {
            ApolloErrorToast(err)
          }}
          onCompleted={() => {
            SuccessToast(`Success`)
            navigate("/d/ecom/dms")
            onClose()
          }}
        />
      }
      width="50%"
      onClose={onClose}
      {...otherProps}
    >
      <div>
        <div>
          <CustomFormGroup label="Ask driver to enter OTP">
            <CustomButton text={otp} style={{ fontWeight: "bold" }} />
          </CustomFormGroup>
        </div>
        <div className="mt-6">
          <CustomFormGroup label="Vehicle is ready to leave the dock at">
            <CustomDatePicker
              fill
              path="timestamp"
              format="MMMM Do YYYY, h:mm:ss A"
              label="Vehicle has arrived at dock at"
              valueAs="object"
              popoverProps={{
                minimal: true,
                position: Position.BOTTOM_RIGHT,
                popoverClassName: "vt-confirm-date-picker-popover",
              }}
              closeOnSelect={false}
              timePickerProps={{
                useAmPm: true,
                showArrowButtons: true,
                precision: TimePrecision.SECOND,
              }}
              value={state.timestamp}
              onChange={handleChange}
            />
          </CustomFormGroup>
        </div>
      </div>
    </CustomDialog>
  )
}

export default ReadyToLeaveDialog
